import { render } from "./CmsProductRootTreeNode.vue?vue&type=template&id=a5312a62&scoped=true"
import script from "./CmsProductRootTreeNode.vue?vue&type=script&lang=js"
export * from "./CmsProductRootTreeNode.vue?vue&type=script&lang=js"

import "./CmsProductRootTreeNode.vue?vue&type=style&index=0&id=a5312a62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5312a62"]])

export default __exports__